import store from "./store.js";
import {browserHistory} from "react-router";
import {syncHistoryWithStore} from "react-router-redux";

let history = syncHistoryWithStore(browserHistory, store);
export default history;


// WEBPACK FOOTER //
// ./src/history.js